import { Command } from '../command-queue/command.interface';
import { ConfigurationManager } from '../configuration-manager/configuration-manager';
import { Configuration } from '../configuration/configuration.model';

export class ConfigCommand implements Command {
  constructor(private configuration: {[key: string]: any}) {
    ConfigurationManager.verifyConfiguration(configuration);
  };

  getCtorArgs(): {[key: string]: any} {
    return this.configuration;
  }

  execute(): Promise<void> {
    ConfigurationManager.applyConfiguration(this.configuration);
    // currently only assumes non async configuration setting.
    // Maybe in the future a configuration setting needs to be async?
    return new Promise(resolve => resolve());
  }
};